/*
 * @Author: Risker-C
 * @Date: 2021-12-06 14:25:23
 * @LastEditTime: 2021-12-25 21:48:46
 * @LastEditors: Risker-C
 * @Description: 
 * @FilePath: \yh2-fms-client\src\views\account\customerManage\view\detail\receivable\index.tsx
 */
import React, { useEffect } from "react";
import { useReceivableModel } from "./receivableModel";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { YhBox } from "@/components/YhBox";
import { ReceivableDataTable } from "./DataTable";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/FmsResourceAuthEnum";
import { Button, message } from "antd";

export const ReceivableDataBox = () => {
    const {
        loadData,
        selectedRowKeys,
        selectedData,
        receivableAmount,
        setApprovalDrawerVisible,
        billCustomerExport,
        exportLoading,
        setSearchParam
    } = useReceivableModel();

    useEffect(() => {
        loadData({ pageNum: 1 },{});
        setSearchParam({})
    }, [])

    const desc: IDescription[] = [
        {
            label: "欠款总计",
            value: receivableAmount?.toFixed(2) ?? '0.00',
            color: DescriptionColorEnum.red
        },
    ]

    const action = (
        <>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                loading={exportLoading}
                onClick={billCustomerExport}
            >
                导出
            </Button>
        </>
    );

    return (
        <>
            <YhBox title={"系统应收"} action={action} descriptions={desc}>
                <ReceivableDataTable />
            </YhBox>
        </>
    )
}